import React, { useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import AddressManagementIcon from "../../assets/icons/admin-customer-icons/address-management";
import ShippingAddressIcon from "../../assets/icons/admin-customer-icons/shipping-address";
import { Form, Formik, useFormikContext } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import {
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
  relationAction,
  updateFamilyAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import DatePicker from "react-datepicker";
import ItemsInputField from "../forms/items-input-field";
import SelectField from "../forms/select-field";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { handelLabel } from "./handel-label";
import { handelEnabled } from "./handel-enabled";
import * as Yup from "yup";
import Family2Icon from "../../assets/icons/admin-customer-icons/family2-icon";
import FamilyMemberIcon from "../../assets/icons/admin-customer-icons/family-member-icon";
import { shouldBeDisplay } from "./shouldBeDisplayed";

function Family({
  customerId,
  family,
  page,
  disabled,
  familyId,
  setCurrentTab,
  customization,
  // loading,
  // setLoading,
}) {
  const [defaultPay, setDefaultPay] = useState("");
  const [defaultShipping, setDefaultShipping] = useState("");
  const [loading, setLoading] = useState(false);
  // const [list, setList] = useState(null);
  const [customData, setcustomData] = useState([]);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const list = [
    { value: "Self", label: "Self" },
    { value: "Father", label: "Father" },
    { value: "Mother", label: "Mother" },
    { value: "Spouse", label: "Spouse" },
    { value: "Son", label: "Son" },
    { value: "Daughter", label: "Daughter" },
    { value: "Brother", label: "Brother" },
    { value: "Sister", label: "Sister" },
    { value: "Father-in-law", label: "Father-in-law" },
    { value: "Mother-in-law", label: "Mother-in-law" },
    { value: "Brother-in-law", label: "Brother-in-law" },
    { value: "Sister-in-law", label: "Sister-in-law" },
    { value: "Son-in-law", label: "Son-in-law" },
    { value: "Daughter-in-law", label: "Daughter-in-law" },
    { value: "Guardian", label: "Guardian" },
  ];

  let initialValues = {
    family: (localStorageData?.family ?? family).map((item, index) => ({
      ...item,
      cmr_dob: item.cmr_dob ? moment(item.cmr_dob).format("YYYY-MM-DD") : "",
      cmr_email: item.cmr_email ? item.cmr_email : "",
    })),
  };
  const addFamily = {
    cmr_id: customerId,
    // cmr_family_id: familyId,
    cmr_full_name: "",
    cmr_relationship: "",
    cmr_dob: "",
    cmr_phone_number: "",
    cmr_email: "",
    cmr_address: "",
    cmr_remarks: "",
    cmr_is_default: false,
  };

  // const UpdateLocalStorage = ({ values }) => {
  //   useEffect(() => {
  //     console.log("initialValues", initialValues);
  //     localStorage.setItem("customerAdmin", JSON.stringify(values));
  //   }, [values]);
  //   return null;
  // };
  //   useEffect(() => {}, []);
  function convertArray(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
    }));
  }
  const onSuccess = (data) => {
    setLoading(false);
    successToast(data.message);
    setCurrentTab("Insurance");
  };
  // const onListSuccess = (data) => {
  //   const res = convertArray(data.data);
  //   setList(res);
  //   setLoading(false);
  // };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.data?.message);
  };

  // useEffect(() => {
  //   if (!loading) {
  //     setLoading(true);
  //     dispatch(relationAction(onListSuccess, onError));
  //   }
  // }, []);

  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
        const updatedData = {
          ...existingData,
          family: values.family,
        };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values, isInitialRender]);

    return null;
  };
  const handleDefaultFamily = (values, setFieldValue, selectedIndex) => {
    const updatedFamily = values.family.map((item, index) => ({
      ...item,
      cmr_is_default: index === selectedIndex,
    }));

    setFieldValue("family", updatedFamily);
  };

  const handleAddFamily = (values, setFieldValue) => {
    const updatedFamily = [...values.family, { ...addFamily }];
    setFieldValue("family", updatedFamily);
  };

  const handleDeleteFamily = (index, values, setFieldValue, length) => {
    if (length === 1) return errorToast("You need atleast one family member");
    else if (values.family[index].cmr_is_default === true) {
      return errorToast("Cannot delete the default family member");
    } else {
      const updatedFamily = values.family.filter((_, i) => i !== index);
      setFieldValue("family", updatedFamily);
    }
  };

  function cleanInvalidDatesFromFamily(family) {
    family.forEach((member) => {
      if (member.cmr_dob === "Invalid date" || member.cmr_dob === "") {
        delete member.cmr_dob;
      }
    });
  }
  const onSave = (values, { validateForm, errors }) => {
    if (loading) return;
    setLoading(true);
    let cleanData = [...values.family];
    cleanInvalidDatesFromFamily(cleanData);
    // let sendData = [...values.family];
    // if (page !== "edit") {
    //   let firstItem = values.family[0];
    //   let updatedFirstItem = {
    //     ...firstItem,
    //     cmr_id: customerId,
    //     cmr_family_id: familyId,
    //   };
    //   sendData[0] = updatedFirstItem;
    // }

    dispatch(updateFamilyAction({ familyData: cleanData }, onSuccess, onError));
  };
  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "family");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]\d{9}$/;

  const validationSchema = Yup.object().shape({
    family: Yup.array().of(
      Yup.object().shape({
        cmr_phone_number: Yup.string()
          .nullable()

          // .required("Phone is required")
          .matches(
            phoneRegex,
            "Please enter a valid 10-digit phone number starting"
          ),

        cmr_email: Yup.string()
          .nullable()
          .test(
            "email-validation",
            "Please enter a valid email address",
            function (value) {
              // If email is null, undefined, or empty string, skip validation
              if (!value || value.trim() === "") {
                return true;
              }
              // If email has a value, validate it
              return emailRegex.test(value);
            }
          ),
      })
    ),
  });
  const today = new Date().toISOString().split("T")[0];

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log(values)}
          <UpdateLocalStorage values={values} />
          {/* <UpdateCmrId customerId={customerId} /> */}
          {/* <UpdateFamilyId familyId={familyId} /> */}
          {/* <LoadingOverlay isLoading={loading} /> */}
          <div className="flex flex-col gap-6 mt-6">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[var(--customer-input-section-icon-from-bg)] to-[var(--customer-input-section-icon-to-bg)] rounded-xl">
                  <Family2Icon />
                </div>
                <div className="flex flex-col justify-between">
                  <label className="text-[length:var(--customer-bold-fs)] font-[var(--customer-current-nav-fw)]">
                    Family Members
                  </label>
                  <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                    Manage patient's family information and relationships
                  </label>
                </div>
              </div>
              <div className="flex gap-[6px]">
                <AddButton
                  prefixIcon={true}
                  // ref={submitRef}
                  isDisabled={disabled || page === "view"}
                  // icon={<Save size={14} />}
                  onclkFn={() => handleAddFamily(values, setFieldValue)}
                  text={<span>Add Family Member</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            </div>
            {values?.family?.map((item, index) => (
              <div
                // key={index}
                className=" px-[34px] pt-[34px] pb-[10px]  flex-col  rounded-2xl  bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]"
              >
                <div className="flex  mb-6 justify-between">
                  <div className="flex flex-row gap-4">
                    <FamilyMemberIcon />
                    <div className="flex flex-col self-center">
                      <label className="h-full text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                        Family Member
                      </label>
                    </div>
                  </div>
                  <div className="flex gap-4 items-center">
                    {item.cmr_is_default ? (
                      <div className="px-5 py-[5px] rounded-full bg-[var(--customer-default-bg)] flex items-center">
                        <label className="text-[var(--customer-default-fg)] font-[var(--customer-default-fw)]">
                          Default
                        </label>
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          if (page !== "view") {
                            handleDefaultFamily(values, setFieldValue, index);
                          }
                        }}
                        className="px-5 py-[5px] rounded-full bg-[var(--customer-set-default-bg)] flex items-center"
                      >
                        <label className="text-[var(--customer-set-default-fg)] font-[var(--customer-default-fw)]">
                          Set as Default
                        </label>
                      </div>
                    )}

                    <button
                      type="button"
                      // disabled={values.pay.length <= 1}
                      onClick={() => {
                        if (page !== "view") {
                          handleDeleteFamily(
                            index,
                            values,
                            setFieldValue,
                            values.family.length
                          );
                        }
                      }}
                      className={`${
                        values.family.length <= 1
                          ? "cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <DeleteIcon />
                    </button>
                  </div>
                </div>
                <div
                  className="grid gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldBeDisplay(
                    "cmr_full_name",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`family[${index}].cmr_full_name`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_full_name",
                          customData
                        )}`}
                        label={handelLabel("cmr_full_name", customData)}
                        isDisabled={handelEnabled(
                          "cmr_full_name",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_relationship",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={list?.find(
                          (option) => option?.label === item?.cmr_relationship
                        )}
                        label={handelLabel("cmr_relationship", customData)}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelEnabled(
                          "cmr_relationship",
                          page,
                          customData
                        )}
                        // errMsgContainerClass="hidden"
                        id={`family[${index}].cmr_relationship`}
                        placeholder={`Select ${handelLabel(
                          "cmr_relationship",
                          customData
                        )}`}
                        options={list}
                        name={`family[${index}].cmr_relationship`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "cmr_dob",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        type="date"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`family[${index}].cmr_dob`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_dob",
                          customData
                        )}`}
                        label={handelLabel("cmr_dob", customData)}
                        isDisabled={handelEnabled("cmr_dob", page, customData)}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        max={today}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldBeDisplay(
                    "cmr_phone_number",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        type="number"
                        // isRequired={true}
                        maxLength={10}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`family[${index}].cmr_phone_number`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_phone_number",

                          customData
                        )}`}
                        label={handelLabel("cmr_phone_number", customData)}
                        isDisabled={handelEnabled(
                          "cmr_phone_number",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}

                  {shouldBeDisplay(
                    "cmr_email",
                    page,

                    customData
                  ) && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        onKeyDown={() => {}}
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="w-full flex  flex-col gap-2  align-end "
                        name={`family[${index}].cmr_email`}
                        placeholder={`Enter ${handelLabel(
                          "cmr_email",
                          customData
                        )}`}
                        label={handelLabel("cmr_email", customData)}
                        type="text"
                        isDisabled={handelEnabled(
                          "cmr_email",
                          page,
                          customData
                        )}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                </div>
                {shouldBeDisplay(
                  "cmr_address",
                  page,

                  customData
                ) && (
                  <div className="flex flex-col gap-2">
                    <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                      {handelLabel("cmr_address", customData)}
                    </label>
                    <TextAreaField
                      name={`family[${index}].cmr_address`}
                      placeholder={`Enter ${handelLabel(
                        "cmr_address",
                        customData
                      )}`}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      label=""
                      isDisabled={handelEnabled(
                        "cmr_address",
                        page,

                        customData
                      )}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                      containerClass="flex flex-col gap-2 w-full "
                    />
                  </div>
                )}
              </div>
            ))}

            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(`/edit-customer-admin/${customerId}`, {
                      state: { tab: "Family Info" },
                    })
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default Family;

function UpdateCmrId({ customerId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.family?.[0] && !Object.hasOwn(values.family[0], "cmr_id")) {
      setFieldValue("family[0].cmr_id", customerId);
    }
  }, [customerId, setFieldValue]);

  return null;
}

function UpdateFamilyId({ familyId }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (
      values.family?.[0] &&
      !Object.hasOwn(values.family[0], "cmr_family_id")
    ) {
      setFieldValue("family[0].cmr_family_id", familyId);
    }
  }, [familyId]);

  return null;
}
